// @flow
import React from 'react';
import nest from 'recompose/nest';
import { withRouter } from 'react-router';

import Profile from 'app/common/components/Profile';
import LocalProfile from 'app/components/LocalProfile';
import { WithRouterParamsProviderV3, withRouterParams } from 'app/common/context/WithRouterParams';
import CommonPage from 'app/common/templates/CommonPage';
import RowLayout from 'app/common/layouts/RowLayout';

import enhanceProfilePage from './enhanceProfilePage';
import { ContentGroup } from 'app/common/templates-next/page-template';
import { shallowEqual, useSelector } from 'react-redux';


// это все для совместимости
const ProfileWRouter = nest(withRouter(WithRouterParamsProviderV3), withRouterParams(Profile));

type Props = {
  title: string,
  header: string,
  close: (e: SyntheticEvent<HTMLElement>) => void,
  field?: string,
  showRemoveLink: boolean,
  introText: string,
  t: (s: string) => string,
  disableFIOEdit: boolean,
}

const ProfilePage = ({ introText, t, disableFIOEdit, route }: Props) => {
  const { loading, phone_enabled: phoneEnabled } = useSelector(state => state.user, shallowEqual);
  const phoneEnabledActual = !loading && phoneEnabled;

  return (
    <CommonPage header={t('profile_page_header')}>
      <RowLayout>
        <ContentGroup header="" transparentBackground={false}>
          <ProfileWRouter
            // showRemoveLink={showRemoveLink}
            showRemoveLink={false}
            introText={introText}
            disableFIOEdit={disableFIOEdit}
            phoneEnabled={phoneEnabledActual}
          >
            {/* Скрыто так как не используется, нужно будет переделывать чтоб открыть */}
            {/* так как field больше не будет использоваться */}
          </ProfileWRouter>
        </ContentGroup>
        <LocalProfile route={route} />
      </RowLayout>
    </CommonPage >
  );
};

export default enhanceProfilePage(ProfilePage);
